export default __webpack_public_path__ + "static/media/calendar.25cd40a6.svg";